import { CumulativeTypes } from "./cumulative-types_enum";

export class CumulativeModel{
    dataIndex:string;
    lableName:string;
    lablecolor:string;
    cumulativeType:CumulativeTypes;
}